export function ChipIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.75 0.75V2.75M12.75 0.75V2.75M6.75 16.75V18.75M12.75 16.75V18.75M2.75 6.75H0.75M2.75 12.75H0.75M18.75 6.75H16.75M18.75 12.75H16.75M4.75 16.75H14.75C15.8546 16.75 16.75 15.8546 16.75 14.75V4.75C16.75 3.64543 15.8546 2.75 14.75 2.75H4.75C3.64543 2.75 2.75 3.64543 2.75 4.75V14.75C2.75 15.8546 3.64543 16.75 4.75 16.75ZM6.75 6.75H12.75V12.75H6.75V6.75Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
